<ng-container *ngIf="{
template: (template$ | async),
init: (columnsService?.formHasBeenInit$ | async)
} as streams$">
  <div class="limiter-header">
    <button
      int-button
      mode="default"
      size="sm"
      class="show-all"
      (click)="showAll()">
      <ng-content select="show-all-label"></ng-content>
    </button>
  </div>

  <ng-container *ngIf="streams$.init">
    <div class="wrap" [formGroup]="columnsService.form">
      <ul class="list">
        <ng-container *ngFor="let record of columnsService.completeList">
          <li class="item" *ngIf="isExistInFormattedList(record)">
            <int-default-checkbox
              [formControlName]="columnsService.getValue(record)"
            >
              <int-empty-divider size="0.8rem"></int-empty-divider>
              <span class="label" *ngIf="!!columnsService.displayedProp">
              <ng-container
                *ngTemplateOutlet="streams$.template
                ? streams$.template
                : listItem; context: {$implicit: record}"
              ></ng-container>
            </span>
            </int-default-checkbox>
          </li>
        </ng-container>
      </ul>
    </div>
  </ng-container>

</ng-container>

<ng-template #listItem let-payload>
  {{ payload[columnsService.displayedProp] }}
</ng-template>
